import firebase, { auth } from '../firebase';


export const loginWithCredentials = (email, password) => auth.setPersistence(
  firebase.auth.Auth.Persistence.LOCAL
).then(() => auth.signInWithEmailAndPassword(email, password));


export const logout = () => auth.signOut();
